module.exports = __webpack_public_path__ + "assets/img/00060.d2f9efc3.png";